export default __webpack_public_path__ + "static/media/download-whitelist.a02737a7.svg";